
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import RadioButton from '@/components/radio-button.vue';
	import Dialog from '@/components/dialog.vue';
  import PickerDate from '@/components/picker-date.vue';
  import {
		lookExpress
	} from '@/api/order'
  import {
    orderSupportremindList,
    orderSupportreturnList
  } from "@/api/after_sales"
	import{
		getSearchDate,
    nextDay
	}from "@/utils/index"
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
			'slz-dialog': Dialog,
      PickerDate,
    }
  })

  export default class ProductList extends Vue {
    private salestype = 0
    private salestypelist = [
      {value:0,label:'确认收货提醒'},
      {value:1,label:'异常物流提醒(买家寄出物流>48小时)'},
    ]
    private keywords = ''
    private filterTime: any = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private logisticsdata:any = {}
    private logisticsmsg:any = []
    private logisticsshow = false
    private lookloading = false


    private mounted () {
      if(this.$route.query.Type){
        this.salestype = Number(this.$route.query.Type)||0
      }
      this.initTime()
      this.changePage(1)
    }



    private async getOvertimeList(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if(this.filterTime){
          let t = this.filterTime.split('/')
          data.StartTime = t[0]
          data.EndTime = nextDay(t[1],1)
        }
        let res = await orderSupportreturnList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            let days = Math.floor(v.ReturnHour/24)
            let hours = v.ReturnHour%24
            v.ReturnHourValue = v.ReturnHour>24?(days+'天'+hours+'小时'):(v.ReturnHour+'小时')
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private clearSearch(){
      this.keywords = ''
      this.initTime()
      this.changePage(1) 
    }
    private doSearch(){
      this.changePage(1)
    }
    private initTime(){
      //近六个月 算上本月 往前推五个月
      let date = new Date((new Date().getTime() - 1000*60*60*24*150))
      let year = date.getFullYear()
      let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1)
      let day = date.getDate()>9?date.getDate():'0'+date.getDate()
      this.filterTime = [year,month,'01'].join('-')+'/'+getSearchDate(0)[0]
    }
    private changePage(e){
      this.pageNo = e
      if(this.salestype==0){
        this.gettablelist()
      }else{
        this.getOvertimeList()
      }
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if(this.filterTime){
          let t = this.filterTime.split('/')
          data.StartTime = t[0]
          data.EndTime = nextDay(t[1],1)
        }
        let res = await orderSupportremindList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private looklogistics(row){
      this.logisticsshow = true
      this.logisticsdata = {
        ExpressValue:row.ReturnExpressValue,
        ExpressNo:row.ReturnExpressNo,
        address:row.ReturnReceiveProvince+row.ReturnReceiveCity+row.ReturnReceiveArea+row.ReturnReceiveAddress,
      }
      let data = {
        ExpressId:row.ReturnExpressId,
        ExpressNo:row.ReturnExpressNo,
        ReceivePhone:row.ReturnReceivePhone,
      }
      this.getlogistics(data)
    }
    private async getlogistics(data){
      try{
        this.lookloading=true
        this.logisticsmsg = []
				let res = await lookExpress(await data)
				if(res.IsSuccess){
					this.logisticsmsg = res.Result.sort((a,b)=>{
            return -1
          }).map((item, index)=>{
						item.color = index===0 ? '#0067cc':'#999';
						return item;
					})
				}
			}finally{
        this.lookloading=false
			}
    }
    private todetail(row){
      this.$router.push({
        path:'/aftersales/detail',
        query:{
          SupportNo:row.SupportNo
        }
      })
    }
    private salestypechange(e){
      this.changePage(1)
    }
  }
